import React from 'react'
import { FormattedNumber } from 'react-intl'

const isInt = (num) => num % 1 === 0

type Props = {
  value: number
  round?: boolean
  currency: string
}

function FormattedCurrency({ value, round = false, currency }: Props) {
  let minimumFractionDigits

  if (['SEK', 'DKK', 'NOK'].includes(currency)) {
    if (round) {
      value = Math.ceil(value)
    }

    if (isInt(value)) {
      minimumFractionDigits = 0
    }
  }

  return (
    <FormattedNumber
      value={value}
      currency={currency}
      style="currency"
      minimumFractionDigits={minimumFractionDigits}
    />
  )
}

export default FormattedCurrency
